module.exports = "/_next/static/files/39f7a6c87b134589d58b03964cdeb2c0.svg";